/*
 * (c) Copyright, 2020, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React, { useContext, useEffect, useState } from 'react'
import Modal from '../Modal'
import { Button } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import FsiPicker from '../FsiPicker'

interface FsiPickerModalProps {
  options?: any
  title?: string
  isOpen?: boolean
  onSelect?: (node: any) => void
  onClose?: () => void
  isNodeSelectable?: (node: any) => boolean
  showAddNewFolderModal?: boolean
  modalClassName?: string
}

const FsiPickerModal: React.FC<FsiPickerModalProps> = ({
  options,
  title,
  isOpen,
  onSelect,
  onClose,
  isNodeSelectable,
  showAddNewFolderModal,
  modalClassName
}) => {
  const [selectedFsi, setSelectedFsi] = useState<any>(null)
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(isOpen ?? false)
  const { t: translate } = useTranslation()

  useEffect(() => {
    setIsDialogOpen(isOpen ?? false)
  }, [isOpen])

  return (
    <Modal show={isDialogOpen} handleClose={onClose ?? (() => {})} className={modalClassName} title={title}>
      <Modal.Body>
        <FsiPicker
          options={options ?? {}}
          onSelect={(node: any) => {
            setSelectedFsi(node)
          }}
          isNodeSelectable={isNodeSelectable}
          showAddNewFolderModal={showAddNewFolderModal ?? false}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button
          data-action={'cancel'}
          variant="link"
          onClick={() => {
            setIsDialogOpen(false)
            onClose?.()
          }}
          id="15c9bcd4-44d0-4665-a770-6de1b34c40ef"
        >
          {translate('CANCEL')}
        </Button>
        <Button
          data-action={'ok'}
          className="btn btn-primary text-capitalize"
          onClick={() => {
            setIsDialogOpen(false)
            if (selectedFsi) {
              onSelect?.(selectedFsi)
            } else {
              onClose?.()
            }
          }}
          id="a8c826e0-e86b-48f4-8345-26c3badd8bf8"
        >
          {translate('OK')}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default FsiPickerModal
